import { IBondGelemMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_YIELD_SHEKEL_MARKET';

export type IReportYieldShekelMarketItem = IBondGelemMarketReport & { __isSelected: boolean };
